import React from 'react';
import { foodCategories } from '../utils/mockData';

export const MenuSection = () => {
  return (
    <section id="menu" className="py-24 bg-gradient-to-b from-[#EBEBD3]/20 to-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#59642C] mb-6">
              What We Serve
            </h2>
            <div className="w-24 h-1 bg-[#FE9E1C] mx-auto mb-6"></div>
            <p className="text-xl text-gray-600">
              Freshly prepared. Chef curated. Designed for workdays.
            </p>
          </div>

          {/* Food Categories Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {foodCategories.map((category, index) => (
              <div
                key={index}
                className="group relative overflow-hidden rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 cursor-pointer"
              >
                {/* Image Container */}
                <div className="aspect-square overflow-hidden bg-gray-100">
                  <img
                    src={category.image}
                    alt={category.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                </div>

                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                {/* Category Name */}
                <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                  <h3 className="text-2xl font-bold text-white group-hover:text-[#FE9E1C] transition-colors duration-300">
                    {category.name}
                  </h3>
                </div>

                {/* Decorative Corner */}
                <div className="absolute top-4 right-4 w-12 h-12 bg-[#FE9E1C] rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <span className="text-white text-xl font-bold">→</span>
                </div>
              </div>
            ))}
          </div>

          {/* Bottom CTA */}
          <div className="mt-16 text-center">
            <p className="text-lg text-gray-600 mb-6">
              Every dish is prepared with care, using fresh ingredients and chef-approved recipes
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
